<template>
  <div>
    <v-toolbar class="contenedor-fechas" color="grey lighten-2" absolute flat height="24em" tabs style="top: 157px;">
      <template slot="extension">
        <v-tabs v-model="currentTab" flat icons-and-text class="pb-4 contenedor-tabs" color="grey lighten-2">
          <v-tab :key="tab.id" @click="handleFechaSelection(tab)" v-for="tab in fechas" class="contenedor-fecha">
            <span>{{ tab.description }}</span>
            <v-icon>fa-calendar</v-icon>
          </v-tab>
        </v-tabs>
      </template>
    </v-toolbar>
  </div>
</template>

<script>

export default {

  data () {
    return {
      currentTab: 0
    }
  },
  props: {
    fechas: [],
    historicTournamentSelectionMode: Boolean,
    urlTournamentAndFechaSelection: Boolean,
    urlFechaSelection: null,
    currentFecha: null
  },
  methods: {
    handleFechaSelection (fechaSelected) {
      this.$emit('fechaSelection', fechaSelected)
    },
    selectUrlFecha () {
      for (let index = 0; index < this.fechas.length; index++) {
        if (this.fechas[index].id.toString() === this.urlFechaSelection) {
          this.currentTab = index
          return this.currentTab
        }
      }
      let currentFechaSelected = this.selectFirstCurrentFecha()
      if (currentFechaSelected) {
        return currentFechaSelected
      }
      this.currentTab = 0
    },
    selectFirstCurrentFecha () {
      for (let index = 0; index < this.fechas.length; index++) {
        if (this.fechas[index].current === true) {
          this.currentTab = index
          return this.currentTab
        }
      }
      this.currentTab = 0
    }
  },

  mounted () {

  },
  watch: {
    async fechas () {
      if (!this.urlTournamentAndFechaSelection) {
        this.selectFirstCurrentFecha()
        this.$emit('fechaSelection', this.fechas[this.currentTab])
      } else {
        this.selectUrlFecha()
        this.$emit('fechaSelection', this.fechas[this.currentTab])
      }
    }
  },
  created () {
    this.urlTournamentAndFechaSelection = false
  }
}
</script>

<style scoped>
.top-spacing {
  margin-top: 5em;
}
.contenedor-fecha{
  padding: 0;
  margin: 0;
}
.contenedor-fechas{
  box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.3), 5px 0px 0px 0px rgba(0,0,0,0.3), 0px 0px 0px 0px rgba(0,0,0,0.12) !important;
}
</style>
